import { Inject, Injectable } from '@angular/core';
import {
  MSAL_GUARD_CONFIG,
  MsalGuardConfiguration,
  MsalService,
} from '@azure/msal-angular';
import { AccountInfo, RedirectRequest } from '@azure/msal-browser';
import { UserService } from '../../api/services/user.service';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  constructor(
    @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,
    private msalService: MsalService,
    private userService: UserService,
  ) {}

  login() {
    this.msalService.loginRedirect({
      ...this.msalGuardConfig.authRequest,
      scopes: [
        ...environment.promotionPowerBIReport.interceptor.scopes,
      ],
    } as RedirectRequest);
  }

  logout() {
    this.userService.removeCache();
    return this.msalService.logoutRedirect();
  }

  clearAllAuthenticationCache() {
    this.userService.removeCache();
    this.msalService.instance.clearCache();
  }

  getToken(scopes: string[]) {
    return this.msalService.acquireTokenSilent({
      scopes,
    });
  }

  isAuthenticated() {
    return this.msalService.instance.getAllAccounts().length > 0;
  }

  getCurrentUser(): AccountInfo {
    if (this.isAuthenticated()) {
      return this.msalService.instance.getActiveAccount() as AccountInfo;
    }

    throw new Error('You must be logged in to access the current user');
  }
}
